<template>
  <v-container fluid>
    <section class="intro-section" id="home">
      <v-row class="align-center px-10" style="height: 690px">
        <v-col md="6" cols="12" class="pa-1 font-weight-bold py-16">
          <h2 class="display-3">Candidate <span class="green--text">Polls</span> & <span
              class="pink--text">Popularity</span>
            Check</h2>
          <v-subheader>Hi, let us help you know your odds at elections.</v-subheader>
          <br>
          <br>
          <v-btn large elevation="5" color="green" to="/register" class="white--text mt-10 px-10 py-5">Sign Up</v-btn>
          <v-row class="mt-16 hidden-sm-and-down">
            <v-chip class="px-4 ma-3" color="primary">
              <v-icon left size="20">mdi-facebook</v-icon>
              Facebook
            </v-chip>
            <v-chip class="px-4 ma-3 white--text" color="#01ff56">
              <v-icon left size="20">mdi-whatsapp</v-icon>
              WhatsApp
            </v-chip>
            <v-chip class="px-4 ma-3" color="info">
              <v-icon left size="20">mdi-instagram</v-icon>
              Instagram
            </v-chip>
          </v-row>
        </v-col>
        <v-col cols="12" md="6">
          <v-row align="center" justify="center" v-if="loading">
            <v-col cols="12" sm="8">
              <v-progress-circular size="75" color="red" indeterminate/>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" v-if="!loading">
            <v-card-text class="mt-12 justify-center">
              <h2
                  class="text-center"
              >Change Your Password</h2>
              <h5
                  class="text-center  grey--text "
              >Follow steps to retrieve your account password </h5>
              <v-row align="center" justify="center">
                <v-col cols="12" sm="8">
                  <v-form ref="form">
                    <v-text-field
                        label="Enter Your Security Code"
                        outlined
                        clearable
                        dense
                        :rules="notEmpty"
                        v-model="userForm.code"
                        color="blue"
                        :autocomplete="false"
                        class="mt-16"
                    />
                    <v-text-field
                        dense
                        v-model="userForm.password"
                        label="Enter Your new Password"
                        type="password"
                        placeholder="mysecretpassword"
                        :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="notEmpty"
                        :type="show ? 'text' : 'password'"
                        @click:append="show = !show"
                        clearable
                        :autocomplete="false"
                        required
                        outlined
                        class="ma-1"
                    />
                    <v-text-field
                        dense
                        v-model="userForm.cpassword"
                        label="Confirm Your New Password"
                        type="password"
                        placeholder="mysecretpassword"
                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="notEmpty"
                        :type="show1 ? 'text' : 'password'"
                        @click:append="show1 = !show1"
                        clearable
                        :autocomplete="false"
                        required
                        outlined
                        class="ma-1"
                    />
                    <v-btn color="blue" class="mt-2 " dark block tile @click="forgotPassword">Request Password change
                    </v-btn>
                  </v-form>

                </v-col>
              </v-row>
            </v-card-text>
          </v-row>
        </v-col>
      </v-row>
    </section>
  </v-container>
</template>

<script>
import {mapActions} from "vuex";
import {postRequest} from "@/api/apirepository";

export default {
  name: "changePassword",
  metaInfo: {
    title: 'Change Password',
  },
  data() {
    return {
      show: false,
      show1: false,
      loading: false,
      userForm: new Form({
        code: "",
        password: "",
        cpassword: "",
      }),
      notEmpty: [
        v => !!v || 'Field is required',
      ],
    }
  },
  methods: {
    ...mapActions([
      "addUser"
    ]),
    forgotPassword() {
      if (this.$refs.form.validate()) {
        if (this.userForm.password !== this.userForm.cpassword) {
          swal.fire('Oops','Passwords dont match','error')
        } else {
          this.loading = true;
          postRequest('changepassword', {
            code: this.userForm.code,
            password: this.userForm.password
          }).then(({data}) => {
            this.$router.push({name: "Login"})
            this.loading = false;
          }).catch(e => {
            this.loading = false;
          })
        }
      }
    }
  }
}
</script>

<style scoped>

</style>